import React, { useCallback } from 'react';
import { Box } from '@mui/material';

export default function LayoutResizeHandle({
  orientation = 'vertical',
  onDragStart,
  onDrag,
  onDragEnd,
}) {
  const handleMouseDown = useCallback((event) => {
    event.preventDefault();
    onDragStart?.(event);

    const cursor = orientation === 'vertical' ? 'col-resize' : 'row-resize';
    document.body.style.cursor = cursor;
    document.body.style.userSelect = 'none';

    const handleMouseMove = (moveEvent) => {
      moveEvent.preventDefault();
      onDrag?.(moveEvent);
    };

    const handleMouseUp = (upEvent) => {
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      onDragEnd?.(upEvent);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  }, [orientation, onDrag, onDragEnd, onDragStart]);

  const isVertical = orientation === 'vertical';

  return (
    <Box
      role="separator"
      aria-orientation={isVertical ? 'vertical' : 'horizontal'}
      onMouseDown={handleMouseDown}
      sx={{
        width: isVertical ? 8 : '100%',
        height: isVertical ? '100%' : 8,
        minWidth: isVertical ? 8 : undefined,
        minHeight: isVertical ? undefined : 8,
        cursor: isVertical ? 'col-resize' : 'row-resize',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        touchAction: 'none',
        borderRadius: 1,
        transition: 'background-color 0.15s ease',
        '&:hover': {
          backgroundColor: 'action.hover',
        },
        '&:active': {
          backgroundColor: 'action.selected',
        },
      }}
    >
      <Box
        sx={{
          width: isVertical ? 2 : 32,
          height: isVertical ? 32 : 2,
          borderRadius: 1,
          backgroundColor: 'divider',
          pointerEvents: 'none',
        }}
      />
    </Box>
  );
}
